import { getVerifications } from "../../../services/api/onboarding/verifications";
import { Await } from "../../../utils";

export const selectorIsEntityVerified = (
  verifications: Await<ReturnType<typeof getVerifications>>
) => {
  const isSomeMainVerified =
    verifications.tax === "Verified" ||
    verifications.banking === "Verified" ||
    verifications.enhanced === "Verified";

  const isSomeProfileVerified = verifications.profiles
    ? Object.values(verifications.profiles).some(
        profile => profile.tax === "Verified"
      )
    : false;

  return isSomeMainVerified || isSomeProfileVerified;
};
